<script lang="ts">
  import {
    useEncodeDataAttribute,
    type ContentSourceMap,
    type StudioPathLike
  } from '@sanity/svelte-loader';
  import { ResponsiveVars, TwistBox, TwistStack } from '@twist/core';
  import { page } from '$app/stores';
  import type { LinkFields } from '$lib/sanity/schemas';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { sanityStudioURL } from '$lib/client';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';
  import BlockButton from '$components/Button/BlockButton.svelte';
  import HeadingSizeDecorator from '$components/Common/HeadingSizeDecorator.svelte';

  export let linksTitle = '';
  export let links: LinkFields[] = [];
  export let titlePath: StudioPathLike = [];
  export let linksPath: StudioPathLike = [];
  export let sourceMap: ContentSourceMap = $page.data.footerSourceMap;

  const brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);

  $: encodeDataAttribute = useEncodeDataAttribute(links, sourceMap, sanityStudioURL);

  const responsiveVars = new ResponsiveVars()
    .addFluid('font-size', toFluidVarInput(18, 18))
    .toCSS();
</script>

<TwistStack
  direction="column"
  align={{ min: 'center', lg: 'flex-start' }}
  spacing={toFluidVarInput(24, 24)}
>
  <div class="heading">
    {#if brandReskinEnabled}
      <HeadingSizeDecorator size="h4">
        <span class="heading-text" data-sanity={encodeDataAttribute(titlePath)}>{linksTitle}</span>
      </HeadingSizeDecorator>
    {:else}
      <h4 class={responsiveVars} data-sanity={encodeDataAttribute(titlePath)}>{linksTitle}</h4>
    {/if}
  </div>

  <TwistBox marginBottom={toFluidVarInput(64, 72)}>
    <TwistStack
      direction="column"
      align={{ min: 'center', lg: 'flex-start' }}
      spacing={toFluidVarInput(24, 24)}
    >
      {#each links as link, index}
        <BlockButton
          href={link.url}
          variant="outline"
          data-sanity={encodeDataAttribute([...linksPath, index, '_id'])}
          data-testid="footer-btn"
        >
          {link.text}
        </BlockButton>
      {/each}
    </TwistStack>
  </TwistBox>
</TwistStack>

<style lang="scss">
  .heading {
    margin-bottom: 6px;

    .heading-text {
      color: var(--theme-general-foreground-color, var(--twist-color-gray-100));
    }
  }

  h4 {
    font-size: var(--font-size);
    font-family: var(--font-family-primary);
    font-weight: 700;
    line-height: 120%;
    color: var(--theme-general-foreground-color, var(--twist-color-gray-100));
  }
</style>
